// extracted by mini-css-extract-plugin
module.exports = {"item":"browse-voucher_item__RjyJ8","tableItem":"browse-voucher_tableItem__3jVz0"};